var React = require('react');

function Issue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 2c7.2 0 13 5.8 13 13s-5.8 13-13 13S2 22.2 2 15 7.8 2 15 2zm0-2C6.7 0 0 6.7 0 15s6.7 15 15 15 15-6.7 15-15S23.3 0 15 0zm-1 18h2V8h-2v10zm0 4h2v-2h-2v2z","fill":"#000","fillRule":"nonzero"}));
}

Issue.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = Issue;

Issue.default = Issue;
